
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2400/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 6.166c.242 0 .444.172.49.4l.01.1V9.5h2.834l.1.01a.501.501 0 010 .98l-.1.01H10.5v2.833a.5.5 0 01-1 0V10.5H6.667a.5.5 0 010-1H9.5V6.666l.01-.1a.501.501 0 01.49-.4z","fill":"#3C464F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 1a9 9 0 110 18 9 9 0 010-18zm0 1a8 8 0 100 16 8 8 0 000-16z","fill":"#3C464F"}})])
          )
        }
      }
    